import type { AppProps } from 'next/app';

import '../styles/global/global.scss';

export default function MyApp({ Component, pageProps }: AppProps) {
  return <Component {...pageProps} />;
}
